import gql from 'graphql-tag';

export default gql`
  mutation updateZeroLessonStatusUserMutation($studentId: MongoID!, $courseId: MongoID!, $zeroLessonStatus: String!) {
    updateZeroLessonStatusUserMutation(
      studentId: $studentId
      courseId: $courseId
      zeroLessonStatus: $zeroLessonStatus
    ) {
      status
    }
  }
`;
